<div class="w-full mx-auto space-y-4 pt-6">

    <!-- Titre -->
    <h1 class="text-2xl font-bold text-gray-900 text-center">{{ 'vues.ipad.visitor-type.title' | translate }}</h1>
    <p class="text-gray-500 text-center mb-4">{{ 'vues.ipad.visitor-type.subtitle' | translate }}</p>

    <!-- Liste des types de visiteurs -->
    <div class="flex flex-col gap-3">
        @for (type of visibleVisitorTypes(); track type.key) {
        <button
            class="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-sm transition"
            (click)="selectVisitorType(type.key)">
            {{ type.label | translate }}
        </button>
        }
    </div>

</div>